<input type="hidden" [id]="'ai-tags-'+startPage" [value]="labelsPageCount">
<div style="display: flex;justify-content: space-around;width: 100%;gap: 20px;" [ngClass]="isExportMode ? 'flex-vertical' : 'flex-horizontal'">
    <div [ngClass]="isExportMode ? 'full-size' : 'half-size'" [class]="'pages page-'+startPage" style="flex-direction: column;">
        <div class="card-by-ai">
            <ion-icon slot="icon-only" src="/assets/imgs/star-shine.svg"></ion-icon>
            {{ 'aiSummary.SelectTagByAi' | translate }}
        </div>
        <div style="height: 350px;display: flex;justify-content: center;" >
            <div [ngClass]="isExportMode ? 'chart-export-mode' : 'full-size'">
                <canvas [id]="chartId" width="100%"></canvas>
            </div>
        </div>
        <div *ngIf="aiBulletPoints?.length" class="legend-container">
            <div class="legend-box-container">
                <div style="width: 15px;height: 15px;background: #707070;"></div>
                <p style="font-size: small;">{{ 'aiSummary.SelectTagPointsTodevelop' | translate }}</p>
            </div>
            <div class="legend-box-container">
                <div style="width: 15px;height: 15px;background: #4462A5;"></div>
                <p style="font-size: small;">{{ 'aiSummary.SelectTagStrengths' | translate }}</p>
            </div>
        </div>
    </div>
    <div *ngIf="aiBulletPoints?.length" [ngClass]="isExportMode ? 'full-size' : 'half-size'" style="display: flex;justify-content: center;">
        <div *ngIf="!isExportMode">
            <div *ngIf="selectedTag == undefined" style="padding: 50px">
                <img src="/assets/imgs/woman_with_magnifier_looking.svg" width="100%" />
                <p style="font-size: large;color: #001E62;">
                    {{ 'aiSummary.SelectTag' | translate }}
                </p>
            </div>
            <div *ngIf="selectedTag != undefined" style="width: 100%;">
                <app-tag-comments-summary
                    [selectedTag]="selectedTag"
                    [aiBulletPointsData]="selectedBulledPoints"
                    [isExportMode]="false"
                ></app-tag-comments-summary>
            </div>
        </div>
        <div *ngIf="isExportMode">
            <div *ngFor="let label of chartLabelsRaw; let i = index" style="width: 100%;">
                <div [class]="'stacked-bullets pages ai-tags-page-'+startPage+'-label-'+getCurrentPageNumber(i)">
                    <app-tag-comments-summary
                        style="width: 100%;"
                        [isExportMode]="true"    
                        [selectedTag]="label"
                        [aiBulletPointsData]="groupedBulledPoints[i]"
                        
                ></app-tag-comments-summary>
                </div>
                
            </div>
        
    </div>

    <div *ngIf="!aiBulletPoints?.length" style="width: 50%;display: flex;justify-content: center;align-items: center;">
        <h2>No data</h2>
    </div>
</div>